import type { ApiPinflGetResponse } from '@/shared/types/api/pinfl';

export type PinflLimitView = {
  // Total taken, including any in-progress amount passed as extraUsed.
  used: number;
  // Ceiling from the dynamic API `limit` (not an env constant).
  ceiling: number;
  // Unified over-limit threshold: trust the backend flag, or fall back to the
  // displayed used exceeding the ceiling (strictly greater — not >=).
  isOver: boolean;
};

// Derives the displayed used/ceiling and the over-limit flag from a PINFL limit
// response. `extraUsed` is any not-yet-committed amount to add on top of the
// backend's used_amount (e.g. the in-progress declaration total).
export const computePinflLimitView = (
  limit: ApiPinflGetResponse,
  extraUsed = 0,
): PinflLimitView => {
  const ceiling = limit.limit;
  const used = limit.used_amount + extraUsed;
  const isOver = limit.is_over_limit || used > ceiling;
  return { used, ceiling, isOver };
};
